<script>
import { mapActions } from 'vuex'
export default {
  name: 'UpdateCatalogueModal',
  props: {
    provider: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions('publishing', ['publishByProvider']),
    async onSubmit() {
      this.loading = true
      const response = await this.publishByProvider(this.provider.id)
      this.$notifier({
        response,
        successMsg: 'Successfully published',
      }).then(success => {
        if (success) {
          this.$modal.self.hide()
        }
      })
      this.loading = false
    },
  },
}
</script>

<template>
  <base-modal title="Update Catalogue from Suppliers">
    <div :class="$style.notice">
      This action will synchronise any new or updated products with all the<br>Suppliers which this Provider has active contracts with.<br>This process may take some time to complete.
      <br>Are you sure you wish to proceed?
    </div>
    <div :class="$style.buttonWrap">
      <el-button
        :class="$style.button"
        type="primary"
        :disabled="loading"
        @click="onSubmit"
      >
        Update Catalogue
      </el-button>
    </div>
  </base-modal>
</template>

<style lang="scss" module>
  .notice {
    margin-bottom: 2rem;
    font-size: .9rem;
    text-align: center;
  }
  .buttonWrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .button {
    width: 12rem;
  }
</style>
